<template>
    <van-dialog
        class="dialog"
        v-model="isShow"
        :show-confirm-button="false"
        :show-cancel-button="false"
        @close="close">
        <div slot="title" class="header-title" :style="{background: $store.state.lingkeColor}">专属服务</div>
        <div class="dialog__content">
            <span class="tips"> {{ form.prompt }}</span>
            <div class="form">
                <div class="form__item" v-for="(item, index) in form.fields" :key="index">
                    <div class="form__label"><span class="required" v-if="item.required">*</span>{{item.name}}</div>
                    <template v-if="isMobile">
                        <template v-if="item.dataType==='string'">
                            <template v-if="item.type==='textarea'">
                                <van-cell-group>
                                    <van-field v-model="userinfo[item.key]" type="textarea" placeholder="请输入" />
                                </van-cell-group>
                            </template>
                            <template v-else-if="item.type==='date'">
                                <van-field v-model="userinfo[item.key]" placeholder="选择日期" @click="showDatePicker = true" />
                                <van-popup v-model="showDatePicker" position="bottom" :get-container="() => popContainer">
                                    <van-datetime-picker
                                        type="date"
                                        v-model="currentDate"
                                        @confirm="popConfirm('showDatePicker', item.key, $event)"
                                        @cancel="showDatePicker = false"
                                    />
                                </van-popup>
                            </template>
                            <template v-else>
                                <van-cell-group>
                                    <van-field v-model="userinfo[item.key]" placeholder="请输入" />
                                </van-cell-group>
                            </template>
                        </template>
                        <template v-if="item.dataType==='number'">
                            <select
                                class="form__select"
                                placeholder="请选择"
                                v-model="userinfo[item.key]">
                                <option v-for="(val, index1) in item.option" :value="val.value" :key="index1">{{val.label}}</option>
                            </select>
                        </template>
                        
                        <!-- <template v-if="item.field_type == 'Text' || item.field_type == 'Number'">
                            <van-cell-group>
                                <van-field v-model="userinfo[item.key]" placeholder="请输入" />
                            </van-cell-group>
                        </template>
                        <template v-if="item.field_type == 'Select'">
                            <select
                                class="form__select"
                                placeholder="请选择"
                                v-model="userinfo[item.key]">
                                <option v-for="(val, index1) in item.option" :value="val" :key="index1">{{val}}</option>
                            </select>
                        </template>
                        <template v-if="item.field_type == 'MultText'">
                            <van-cell-group>
                                <van-field v-model="userinfo[item.key]" type="textarea" placeholder="请输入" />
                            </van-cell-group>
                        </template>
                        <template v-if="item.field_type == 'Date'">
                            <van-field v-model="userinfo[item.key]" placeholder="选择日期" @click="showDatePicker = true" />
                            <van-popup v-model="showDatePicker" position="bottom" :get-container="() => popContainer">
                                <van-datetime-picker
                                    type="date"
                                    v-model="currentDate"
                                    @confirm="popConfirm('showDatePicker', item.key, $event)"
                                    @cancel="showDatePicker = false"
                                />
                            </van-popup>
                        </template>
                        <template v-if="item.field_type == 'Time'">
                            <van-field v-model="userinfo[item.key]" placeholder="选择时间" @click="showTimePicker = true" />
                            <van-popup v-model="showTimePicker" position="bottom" :get-container="() => popContainer">
                                <van-datetime-picker
                                    type="time"
                                    v-model="currentTime"
                                    @confirm="popConfirm('showTimePicker', item.key, $event)"
                                    @cancel="showTimePicker = false"
                                />
                            </van-popup>
                        </template>
                        <template v-if="item.field_type == 'CheckBox'">
                            <van-checkbox-group v-model="userinfo[item.key]" direction="horizontal" class="form-item__bg">
                                <van-checkbox v-for="(val, k) in item.option" :name="val" :key="k" shape="square">{{ val }}</van-checkbox>
                            </van-checkbox-group>
                        </template>
                        <template v-if="item.field_type == 'Radio'">
                            <van-radio-group v-model="userinfo[item.key]" direction="horizontal" class="form-item__bg">
                                <van-radio v-for="(val, k) in item.option" :name="val" :key="k">{{ val }}</van-radio>
                            </van-radio-group>
                        </template> -->
                    </template>
                    <template v-else>
                        <template v-if="item.dataType==='string'">
                            <template v-if="item.type==='textarea'">
                                <el-input v-model="userinfo[item.key]" type="textarea" placeholder="请输入"></el-input>
                            </template>
                            <template v-else-if="item.type==='date'">
                                <el-date-picker prefix-icon="none" v-model="userinfo[item.key]" type="date" value-format="timestamp" placeholder="选择日期"></el-date-picker>
                            </template>
                            <template v-else>
                                <el-input v-model="userinfo[item.key]" placeholder="请输入"></el-input>
                            </template>
                        </template>
                        <template v-if="item.dataType==='number'">
                            <el-select v-model="userinfo[item.key]" placeholder="请选择">
                                <el-option
                                    v-for="(val, index1) in item.option"
                                    :key="index1"
                                    :label="val.label"
                                    :value="val.value">
                                </el-option>
                            </el-select>
                        </template>
                        <!-- <template v-if="item.field_type == 'Text' || item.field_type == 'Number'">
                            <el-input v-model="userinfo[item.key]" placeholder="请输入"></el-input>
                        </template>
                        <template v-if="item.field_type == 'Select'">
                            <el-select v-model="userinfo[item.key]" placeholder="请选择">
                                <el-option
                                    v-for="(val, index1) in item.option"
                                    :key="index1"
                                    :label="val"
                                    :value="val">
                                </el-option>
                            </el-select>
                        </template>
                        <template v-if="item.field_type == 'MultText'">
                            <el-input v-model="userinfo[item.key]" type="textarea" placeholder="请输入"></el-input>
                        </template>
                        <template v-if="item.field_type == 'Date'">
                            <el-date-picker prefix-icon="none" v-model="userinfo[item.key]" type="date" value-format="timestamp" placeholder="选择日期"></el-date-picker>
                        </template>
                        <template v-if="item.field_type == 'Time'">
                            <el-time-picker prefix-icon="none" v-model="userinfo[item.key]" value-format="timestamp" placeholder="选择时间"></el-time-picker>
                        </template>
                        <template v-if="item.field_type == 'CheckBox'">
                            <el-checkbox-group v-model="userinfo[item.key]">
                                <el-checkbox v-for="(val,k) in item.option" :key="k" :label="val">{{val}}</el-checkbox>
                            </el-checkbox-group>
                        </template>
                        <template v-if="item.field_type == 'Radio'">
                            <el-radio-group v-model="userinfo[item.key]">
                                <el-radio v-for="(val,k) in item.option" :key="k" :label="val">{{val}}</el-radio>
                            </el-radio-group>
                        </template> -->
                    </template>
                    <p class="frm-err" v-if="err.inc">{{err.parentTag}}</p>
                </div>
                <div class="form__item" v-if="isMobile">
                    <div class="form__label"><span class="required" >*</span>是否愿意接受我们的回访</div>
                    <div class="radio_type_div">
                        <input type="radio" name="jieshou" class="radio_type" value="1" checked="checked"/>愿意接受
                    </div>
                    <div class="radio_type_div">
                        <input type="radio" name="jieshou" class="radio_type" value="2"/>不接受
                    </div>
                </div>
                <div class="form__item" v-else>
                    <div class="form__label"><span class="required" >*</span>是否愿意接受我们的回访</div>
                    <el-radio-group v-model="huifang">
                        <el-radio v-for="(val,k) in huifangoption" :key="k" :label="val">{{val}}</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div slot="default" class="dialog-footer" :style="{background: $store.state.lingkeColor}" @click="confirm">
            进入咨询
        </div>
    </van-dialog>
</template>

<script>
    //import get from 'lodash.get'
    import { Field, CellGroup, Popup, DatetimePicker, Radio, RadioGroup, Checkbox, CheckboxGroup } from 'vant'
    import { postBefore } from '@/api/before'
    import { SHOW_BEFORE_DIALOG } from '@/constants/pub_sub'
    import { pattern } from '@/utils/pattern'

    export default {
        name: 'TheBeforeDialog',
        data () {
            return {
                currentDate: new Date(),
                currentTime: `${new Date().getHours()}:${new Date().getMinutes()}`,
                popContainer: document.querySelector('body'),
                isShow: false,
                form: {},
                userinfo: {},
                err: [],
                huifang: '愿意接受',
                huifangoption: ['愿意接受', '不接受'],
                showTimePicker: false,
                showDatePicker: false
            }
        },
        components: {
            [Field.name]: Field,
            [CellGroup.name]: CellGroup,
            [Popup.name]: Popup,
            [Radio.name]: Radio,
            [RadioGroup.name]: RadioGroup,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [DatetimePicker.name]: DatetimePicker
        },
        computed: {
            isMobile () {
                return this.$eventBus.isMobile
            },
        },
        watch: {
            isShow (value) {
                if (value) {
                    this.init()
                }
            },
        },
        methods: {
            init () {
                this.form.fields.forEach(val => {
                    if (val.field_type == 'CheckBox') {
                        this.$set(this.userinfo, val.key, [])
                    } else {
                        this.$set(this.userinfo, val.key, '')
                    }
                    
                })
            },
            popConfirm (popBox, key, val) {
                if (val instanceof Date) {
                    const y = new Date(val).getFullYear()
                    const mon = new Date(val).getMonth() + 1
                    const d = new Date(val).getDate()
                    this.userinfo[key] = `${y}-${mon < 10 ? '0' + mon : mon}-${d < 10 ? '0' + d : d}`
                }
                else {
                    this.userinfo[key] = val
                }
                this[popBox] = false
            },
            validator () {
                let v = this
                let valid = false
                try {
                    this.form.fields.forEach((val) => {
                        if (val.required) {
                            if (this.userinfo[val.key] === '') {
                                if (val.field_type == 'Select' || val.field_type == 'Date' || val.field_type == 'Time' || val.field_type == 'Radio') {
                                    v.$toast('请选择' + val.name)
                                } else {
                                    v.$toast('请输入' + val.name)
                                }
                                valid = true
                                throw new Error('')
                            }
                            
                            if (val.field_type == 'CheckBox') {
                                if (this.userinfo[val.key].length == 0) {
                                    v.$toast('请选择' + val.name)
                                    valid = true
                                    throw new Error('')
                                }
                            }
                        }
                        // 有值情况才校验
                        if (this.userinfo[val.key]) {
                            if (val.key == 'mobile') {
                                if (!(pattern('tel').test(this.userinfo[val.key]))) {
                                    v.$toast('请输入正确的' + val.name)
                                    valid = true
                                    throw new Error('')
                                }
                            }
                            if (val.key == 'email') {
                                if (!(pattern('email').test(this.userinfo[val.key]))) {
                                    v.$toast('请输入正确的' + val.name)
                                    valid = true
                                    throw new Error('')
                                }
                            }
                            if (val.field_type == 'Number') {
                                if (!(pattern('number').test(this.userinfo[val.key]))) {
                                    v.$toast('请输入正确的数字')
                                    valid = true
                                    throw new Error('')
                                }
                            }
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
                return valid
            },
            async confirm () {
                if (this.validator()) {
                    return
                }
                let data = {
                    e: this.$eventBus.entryKey,
                    chat_user_id: this.$eventBus.uid
                }
                const userinfo = Object.keys(this.userinfo).reduce((acc, k) => {
                    const sameKeyO = this.form.fields.find(x => x.key === k)
                    if (sameKeyO && sameKeyO.field_type === 'Date') {
                        acc[k] = new Date(this.userinfo[k]).getTime()
                    }
                    else if (sameKeyO && sameKeyO.field_type === 'Time') {
                        const y = new Date().getFullYear()
                        const mon = new Date().getMonth() + 1
                        const d = new Date().getDate()
                        acc[k] = new Date(`${y}-${mon}-${d} ${this.userinfo[k]}`).getTime()
                    }
                    else {
                        console.log('k', this.userinfo[k], typeof this.userinfo[k])
                        acc[k] = this.userinfo[k]
                    }
                    return acc
                }, {})
                let newdata = Object.assign(data, userinfo)
                try {
                    await postBefore(newdata)
                    this.$toast('提交成功')
                    this.$eventBus.$emit('insertRobotWelcome')
                    this.isShow = false
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                }
            },
            reset () {
                
            },
            close () {
                this.reset()
            }
        },
        created () {
            this.$eventBus.$on(SHOW_BEFORE_DIALOG, (val) => {
                this.form = val
                this.isShow = true
            })
        },
        beforeDestroy () {
            this.$eventBus.$off(SHOW_BEFORE_DIALOG)
        }
    }
</script>

<style lang="scss" scoped>
    .dialog {
        top: 50%;
    }
    /deep/ .van-dialog__header {
        padding-top: 0;
    }
    .header-title {
        color: #fff;
        height: 43px;
        line-height: 43px;
        font-size: 14px;
    }
    
    .van-dialog {
        width: 80vw;
    }
    .dialog__content {
        height: 60vh;
        // max-height: 500px;
        overflow-y: auto;
        background: #f5f7fa;
    }

    .tips {
        display: block;
        margin: 15px 15px 0 15px;
        font-size: 12px;
        color: #333;
    }
    /deep/.form-item__bg {
        padding: 5px 16px 10px;
        background: #fff;
        .van-checkbox,
        .van-radio {
            margin-top: 5px;
        }
        .van-radio__icon {
            font-size: 16px;
        }
        .van-radio__label {
            font-size: 14px;
        }
    }
    .form {
        &__item {
            text-align: left;
            &:last-child {
                margin-bottom: 24px;
            }
            .radio_type_div {
                padding: 15px;
                background: #fff;
                color: #333;
                font-size: 12px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .radio_type {
                    width: 20px;
                    height: 20px;
                    appearance: none;
                    position: relative;
                    outline: none;
                    &:before {
                        content: "";
                        width: 15px;
                        height: 15px;
                        border: 1px solid #0075ff;
                        display: inline-block;
                        border-radius: 50%;
                        vertical-align: middle;
                    }
                    &:checked:before {
                        content: "";
                        width: 15px;
                        height: 15px;
                        border: 1px solid #0075ff;
                        display: inline-block;
                        border-radius: 50%;
                        vertical-align: middle;
                    }
                    &:checked:after {
                        content: "";
                        width: 9px;
                        height: 9px;
                        text-align: center;
                        background: #0075ff;
                        border-radius: 50%;
                        display: block;
                        position: absolute;
                        top: 5px;
                        left: 3px;
                    }
                    &:checked + label {
                        color: #edd19d;
                    }
                }
                &:last-child {
                    padding-top: 0;
                }
            }
        }

        &__label {
            color: #151515;
            font-weight: bold;
            font-size: 12px;
            margin: 15px 0 10px 15px;
            display: flex;
            justify-content: flex-start;
            .required {
                display: block;
                margin-right: 4px;
                color: #f03d3d;
                font-size: 12px;
                position: relative;
                top: 3px;
            }
        }
        .form__label {
            font-size: 14px;
        }

        &__income {
            display: block;
            width: 100%;
            height: 40px;
            border: none;
            line-height: 40px;
            font-size: 14px;
            padding-left: 15px;
        }

        &__select {
            display: block;
            width: 100%;
            height: 40px;
            line-height: 40px;
            border: none;
            font-size: 14px;
            padding-left: 15px;

            option {
                height: 40px;
            }
        }
    }

    .dialog-footer {
        text-align: center;
        cursor: pointer;
        color: #fff;
        height: 43px;
        line-height: 43px;
        font-size: 14px;
    }
    /deep/ .el-input {
        .el-input__inner {
            border: none;
        }
    }
    /deep/ .el-textarea {
        .el-textarea__inner {
            border: none;
        }
    }
    .el-select {
        width: 100%;
    }
    .el-date-editor {
        width: 100%;
    }
    .el-radio-group {
        width: 100%;
        background: #fff;
        padding: 15px;
        display: flex;
        flex-direction: column;
        label:nth-of-type(n+2) {
            margin-top: 10px;
        }
    }
    .el-checkbox-group {
        width: 100%;
        background: #fff;
        padding: 15px;
        display: flex;
        flex-direction: column;
        label:nth-of-type(n+2) {
            margin-top: 10px;
        }
    }
</style>
